// extracted by mini-css-extract-plugin
module.exports = {"content":"_1A4PQWUMNx","top":"_3A74tJMC9G","width-160":"_3CxIrS1ufX","marginR":"_2dHry0iMc4","edit-text":"_3HdrTWg6Z1","clear-text":"_38uLBPEg-A","phone":"_1gcLQn-h4a"};